import Layout from '@/layout';
var travelRouter = {
  path: '/travel',
  component: Layout,
  redirect: '/travel/stay',
  name: 'Travel',
  meta: {
    title: '旅居管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'stay',
    name: 'TravelStay',
    component: function component() {
      return import('@/views/travel/stay');
    },
    meta: {
      title: '旅居酒店',
      icon: ''
    }
  }, {
    path: 'stay/create',
    name: 'TravelStayCreate',
    component: function component() {
      return import('@/views/travel/stay/create');
    },
    meta: {
      title: '添加房型',
      icon: '',
      activeMenu: '/travel/stay'
    },
    hidden: true
  }, {
    path: 'stay/create/:id',
    name: 'TravelStayEdit',
    component: function component() {
      return import('@/views/travel/stay/create');
    },
    meta: {
      title: '编辑房型',
      icon: '',
      activeMenu: '/travel/stay'
    },
    hidden: true
  }, {
    path: 'stay/price/:stayId',
    name: 'TravelStayPrice',
    component: function component() {
      return import('@/views/travel/stay/price');
    },
    meta: {
      title: '日历价格',
      icon: '',
      activeMenu: '/travel/stay'
    },
    hidden: true
  }, {
    path: 'stay/merchant-info',
    name: 'TravelStayMerchantInfo',
    component: function component() {
      return import('@/views/travel/stay/merchantInfo');
    },
    meta: {
      title: '酒店信息',
      icon: ''
    }
  }, {
    path: 'food',
    name: 'TravelFood',
    component: function component() {
      return import('@/views/travel/food');
    },
    meta: {
      title: '美食团购',
      icon: ''
    }
  }, {
    path: 'food/create',
    name: 'TravelFoodCreate',
    component: function component() {
      return import('@/views/travel/food/create');
    },
    meta: {
      title: '添加美食',
      icon: '',
      activeMenu: '/travel/food'
    },
    hidden: true
  }, {
    path: 'food/create/:id',
    name: 'TravelFoodEdit',
    component: function component() {
      return import('@/views/travel/food/create');
    },
    meta: {
      title: '编辑美食',
      icon: '',
      activeMenu: '/travel/food'
    },
    hidden: true
  }, {
    path: 'tour',
    name: 'TravelTour',
    component: function component() {
      return import('@/views/travel/tour');
    },
    meta: {
      title: '线路门票',
      icon: ''
    }
  }, {
    path: 'tour/create',
    name: 'TravelTourCreate',
    component: function component() {
      return import('@/views/travel/tour/create');
    },
    meta: {
      title: '添加线路',
      icon: '',
      activeMenu: '/travel/tour'
    },
    hidden: true
  }, {
    path: 'tour/create/:id',
    name: 'TravelTourEdit',
    component: function component() {
      return import('@/views/travel/tour/create');
    },
    meta: {
      title: '编辑线路',
      icon: '',
      activeMenu: '/travel/tour'
    },
    hidden: true
  }]
};
export default travelRouter;